import { useState, useEffect, useCallback } from 'react'
import ServiceSecurity, { IPlayer } from '../Services/ServiceSecurity'
import { tokenStore } from '../storage/tokenStore'
import { WooNotesButton } from './WooNotesButton'
import { WooNotesTextInput } from './WooNotesTextInput'
import { WooNotesPasswordInput } from './WooNotesPasswordInput'
import { WooNotesErrorAlert } from './WooNotesErrorAlert'
import './WooNotes.css'
import './WooLogin.css'
import { lastUsernameStore } from '../storage/lastUsernameStore'
import { Unauthorized } from '../Errors/Unauthorized'
import Util from '../Util'
import { WooNotesInfoAlert } from './WooNotesInfoAlert'

interface IWooLoginProps {
  logo?: boolean
  onLogin: (token: string, player: IPlayer) => void
  reasonForLogout?: string
}

const WooLogin = ({ logo, onLogin, reasonForLogout }: IWooLoginProps) => {
  const [username, setUsername] = useState<string>(() => lastUsernameStore.get() ?? '')
  const [password, setPassword] = useState<string>()
  const [token, setToken] = useState('')
  const [validateToken, setValidateToken] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const [errorMsg, setErrorMsg] = useState('')
  const [tryingStoredToken, setTryingStoredToken] = useState('') //!!(tokenStore.get() ?? ''))
  const [tryingToLoginViaCookie, setTryingToLoginViaCookie] = useState(true)

  const [infoTitle, setInfoTitle] = useState('')
  const [infoMsg, setInfoMsg] = useState('')
  useEffect(() => {
    if (errorMsg) return
    setInfoTitle('Reason for auto logout')
    setInfoMsg(reasonForLogout ?? '')
  }, [reasonForLogout])

  useEffect(() => {
    if (!errorMsg) return
    setInfoTitle('')
    setInfoMsg('')
  }, [errorMsg])

  useEffect(() => {
    const callFetchLoginCookieInfo = async () => {
      try {
        const loginCookieInfo = await ServiceSecurity.fetchLoginCookieInfo()
        if (loginCookieInfo?.AuthorizationToken) {
          setTryingStoredToken(loginCookieInfo.AuthorizationToken)
        }
      } finally {
        setTryingToLoginViaCookie(false)
      }
      //console.log(`loginCookieInfo`, loginCookieInfo)
    }

    const storedToken = tokenStore.get() ?? ''
    if (storedToken) {
      setTryingStoredToken(storedToken)
      setTryingToLoginViaCookie(false)
    } else {
      callFetchLoginCookieInfo()
    }
  }, [validateToken])

  useEffect(() => {
    if (!tryingStoredToken) return

    const doValidateToken = async () => {
      try {
        const playerExtendedInfo = await ServiceSecurity.fetchPlayerExtendedInfo(tryingStoredToken, 'editor')
        onLogin?.(tryingStoredToken, playerExtendedInfo.Player)
        setToken(tryingStoredToken)
      } catch (err) {
        if (err instanceof Unauthorized) {
          setTryingStoredToken('')
        } else {
          setErrorMsg('Error validating')
        }
      }
    }

    doValidateToken()
  }, [tryingStoredToken])

  useEffect(() => {
    if (token) {
      setPassword('')
    }
  }, [token])

  const tryLogin = useCallback(async (username: string, password: string) => {
    setSubmitting(true)
    setErrorMsg('')
    try {
      console.log(`tryLogin`, username, password)
      const token = await ServiceSecurity.fetchToken(
        {
          username,
          password,
        },
        'editor',
      )
      console.log('store username', username)
      lastUsernameStore.set(username ?? '')
      tokenStore.set(token)
      setValidateToken(token)
    } catch (err) {
      if (err instanceof Error) {
        setErrorMsg(err.message)
      } else {
        setErrorMsg('Failed logging in')
      }
    } finally {
      setSubmitting(false)
    }
  }, [])

  if (tryingStoredToken || tryingToLoginViaCookie) return null

  return (
    <>
      {!!logo && <img src="/icons/woonotes/woonotes462wide.png" style={{ width: '100%', marginBottom: 10 }} />}

      <WooNotesTextInput
        //ref={userRef}
        label="Username"
        value={username}
        onChange={e => {
          setUsername(e.target.value)
          setErrorMsg('')
        }}
        //onBlur={() => syncFromDom()}
        placeholder="Enter username..."
        // autoComplete="username"
        autoComplete="off"
        autoCorrect="off"
        autoCapitalize="none"
        // defaultValue="" // <- uncontrolled
        // name="username"
        // data-lpignore="true"
        autoFocus={!username}
        onKeyDown={e => {
          if (e.key === 'Enter') {
            tryLogin(username ?? '', password ?? '')
          }
        }}
      />

      <WooNotesPasswordInput
        //ref={passRef}
        label="Password"
        value={password}
        onChange={e => {
          setPassword(e.target.value)
          setErrorMsg('')
        }}
        //onBlur={() => syncFromDom()}
        placeholder="••••••••"
        //autoComplete="off"
        autoCorrect="off"
        autoCapitalize="none"
        autoComplete="new-password"
        // autoComplete="current-password"
        // defaultValue="" // <- uncontrolled
        // name="password"
        // data-lpignore="true"
        autoFocus={!!username}
        onKeyDown={e => {
          if (e.key === 'Enter') {
            tryLogin(username ?? '', password ?? '')
          }
        }}
      />

      <WooNotesButton
        fullWidth
        disabled={/*!username.trim() || !password.trim() || */ submitting}
        onClick={() => tryLogin(username ?? '', password ?? '')}
        style={{ marginTop: 20, marginBottom: 20 }}
      >
        Login
      </WooNotesButton>

      {!!errorMsg && (
        <div style={{ position: 'absolute', top: '100%', width: '100%', alignItems: 'center', justifyItems: 'center', marginTop: 20 }}>
          <div style={{}}>
            <WooNotesErrorAlert message={errorMsg} />
          </div>
        </div>
      )}
      {!!infoMsg && (
        <div style={{ position: 'absolute', top: '100%', width: '100%', alignItems: 'center', justifyItems: 'center', marginTop: 20 }}>
          <div style={{}}>
            <WooNotesInfoAlert title={infoTitle} message={infoMsg} />
          </div>
        </div>
      )}
    </>
  )
}

export default WooLogin
